<template>
  <div style="position: relative;">
    <!--    <div class="update-wrap">-->
    <!--      <span>{{ $t('Fota.dataUpdate') }} {{ time }}</span>-->
    <!--      <svg style="color: #2046c7" class="icon" aria-hidden="true" @click="handleLook">-->
    <!--        <use xlink:href="#icon-question1"></use>-->
    <!--      </svg>-->
    <!--    </div>-->
    <!--    <div class="statistics" >
      <div class="statistics-left">
        <CardContainer style="height: 100%;">
          <div class="title">{{ $t('Fota.deviceTotal') }}</div>
          <div class="total">{{ deviceTotal }}</div>
          <div class="day-wrap">
            <span class="label">{{ $t('Fota.todayNum') }}</span>
            <span class="value">{{ deviceDay }}</span>
          </div>
          <div class="img"></div>
        </CardContainer>
      </div>
      <div class="statistics-right">
        <CardContainer style="height: 100%;">
          <div class="left-div device">
            <div class="total">{{ deviceRequestTotal }}</div>
            <div class="day-wrap">
              <span class="label">{{ $t('Fota.todayNum') }}</span>
              <span class="value">{{ deviceRequestDay }}</span>
            </div>
            <div class="name">{{ $t('Fota.deviceRequestTotal') }}</div>
          </div>
          <div class="left-div fota">
            <div class="total">{{ fotaSuccessTotal }}</div>
            <div class="day-wrap">
              <span class="label">{{ $t('Fota.todayNum') }}</span>
              <span class="value">{{ fotaSuccessDay }}</span>
            </div>
            <div class="name">{{ $t('Fota.fotaSuccessTotal') }}</div>
          </div>
          <div class="fota-query">
            <div class="total">{{ fotaRequestTotal }}</div>
            <div class="day-wrap">
              <span class="label">{{ $t('Fota.todayNum') }}</span>
              <span class="value">{{ fotaRequestDay }}</span>
            </div>
            <div class="name">{{ $t('Fota.fotaRequestTotal') }}</div>
            <el-progress
              type="circle"
              :width="84"
              :stroke-width="10"
              :percentage="requestProgress"
              color="#00CBD3"
            ></el-progress>
          </div>
        </CardContainer>
      </div>
    </div>-->
    <CardContainer class="version">
      <div class="title">{{ $t('Fota.versionDistribution') }}</div>
      <div style="display: flex;">
        <div style="flex: 1;">
          <div class="left-wrap">
            <div class="one" v-if="tableData.length > 0">
              <Bubble
                :size="166"
                :number="tableData[0].count"
                :version="tableData[0].version"
                :progress="Number(tableData[0].percent)"
                :dayNumber="tableData[0].increasedCount"
              />
            </div>
            <div class="two" v-if="tableData.length > 1">
              <Bubble
                :size="145"
                :number="tableData[1].count"
                :version="tableData[1].version"
                :progress="Number(tableData[1].percent)"
                :dayNumber="tableData[1].increasedCount"
              />
            </div>
            <div class="three" v-if="tableData.length > 2">
              <Bubble
                :size="120"
                :number="tableData[2].count"
                :version="tableData[2].version"
                :progress="Number(tableData[2].percent)"
                :dayNumber="tableData[2].increasedCount"
              />
            </div>
            <div class="four" v-if="tableData.length > 3">
              <Bubble
                :size="110"
                :number="tableData[3].count"
                :version="tableData[3].version"
                :progress="Number(tableData[3].percent)"
                :dayNumber="tableData[3].increasedCount"
              />
            </div>
            <div class="five" v-if="tableData.length > 4">
              <Bubble
                :size="100"
                :number="tableData[4].count"
                :version="tableData[4].version"
                :progress="Number(tableData[4].percent)"
                :dayNumber="tableData[4].increasedCount"
              />
            </div>
            <div class="six" v-if="tableData.length > 5">
              <Bubble
                :size="70"
                :number="tableData[5].count"
                :version="tableData[5].version"
                :progress="Number(tableData[5].percent)"
                :dayNumber="tableData[5].increasedCount"
              />
            </div>
            <Empty class="hl-empty" v-if="tableData.length === 0" />
          </div>
        </div>
        <div class="right-wrap">
          <el-table :data="tableData">
            <el-table-column prop="version" :label="$t('Fota.VersionNum')"></el-table-column>
            <el-table-column prop="count" :label="$t('Fota.deviceNum')">
              <template slot-scope="scope">
                <span class="device-count">{{ scope.row.count }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="percent" :label="$t('Fota.versionPercent')">
              <template slot-scope="scope">
                <span>{{ scope.row.percent }}%</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="total">{{ $t('Fota.total') }}{{ ':' }}{{ tableData.length }}</div>
        </div>
      </div>
    </CardContainer>
    <DataUpdate v-if="showModel" :showModel.sync="showModel" />
  </div>
</template>

<script>
import Bubble from './Bubble'
import DataUpdate from './DataUpdate'
import Empty from '@/components/Empty'
export default {
  name: 'Data',
  components: {
    Bubble,
    DataUpdate,
    Empty
  },
  data() {
    return {
      time: '01:00:00',
      deviceTotal: 0,
      deviceDay: 0,
      deviceRequestTotal: 0,
      deviceRequestDay: 0,
      fotaSuccessTotal: 0,
      fotaSuccessDay: 0,
      fotaRequestTotal: 0,
      fotaRequestDay: 0,
      showModel: false,
      tableData: []
    }
  },
  computed: {
    requestProgress() {
      if (this.fotaRequestTotal === 0) {
        return 0
      }
      return Number(((this.fotaRequestDay / this.fotaRequestTotal) * 100).toFixed(2))
    }
  },
  mounted() {
    // 关键指标
    this.getKeyIndex()
    // 版本分布
    this.getVersionDistribution()
  },
  methods: {
    getKeyIndex() {
      let params = {
        firmwareType: 'DTU'
      }
      this.$ajax
        .get(this.$api.fota.firmware_key_index, params)
        .then((res) => {
          this.time = res.data.time
          this.deviceTotal = res.data.deviceCount
          this.deviceDay = res.data.deviceCountToday
          this.deviceRequestTotal = res.data.requestCount
          this.deviceRequestDay = res.data.requestCountToday
          this.fotaSuccessTotal = res.data.otaSuccessCount
          this.fotaSuccessDay = res.data.otaSuccessCountToday
          this.fotaRequestTotal = res.data.otaCount
          this.fotaRequestDay = res.data.otaCountToday
        })
        .catch(() => {})
    },
    getVersionDistribution() {
      let params = {
        firmwareType: 'DTU',
        pageNumber: 1,
        pageSize: 99999
      }
      this.$ajax
        .get(this.$api.fota.firmware_version_distribution, params)
        .then((res) => {
          this.tableData = res.data.list
        })
        .catch(() => {})
    },
    handleLook() {
      this.showModel = true
    }
  }
}
</script>

<style lang="scss" scoped>
.update-wrap {
  position: absolute;
  top: -60px;
  right: 0;
  line-height: 22px;
  font-size: 14px;
  color: #666666;
  .icon {
    margin-left: 4px;
    font-size: 16px;
    cursor: pointer;
  }
}
.statistics {
  display: flex;
  .statistics-left {
    position: relative;
    flex: 1;
    height: 194px;
    .title {
      line-height: 24px;
      font-size: 16px;
      color: #666666;
    }
    .total {
      line-height: 56px;
      font-family: Barlow-SemiBold;
      font-size: 48px;
      font-weight: 600;
      color: #333333;
    }
    .day-wrap {
      position: absolute;
      left: 24px;
      bottom: 24px;
      line-height: 24px;
      font-size: 16px;
      .label {
        margin-right: 8px;
        color: #999999;
      }
      .value {
        font-weight: 600;
        color: #666666;
      }
    }
    .img {
      position: absolute;
      right: 24px;
      bottom: 24px;
      width: 48px;
      height: 48px;
      background-image: url('../../../assets/device.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .statistics-right {
    flex: 3;
    height: 194px;
    margin-left: 24px;
    /deep/ .el-card__body {
      display: flex;
      .left-div {
        position: relative;
        flex: 2;
        margin-left: 24px;
        padding: 24px;
        height: 146px;
        background-repeat: no-repeat;
        background-position: left center;
        background-size: cover;
        border-radius: 15px;
        &:first-child {
          margin-left: 0;
        }
        &.device {
          background-image: url('../../../assets/device_added_bg.jpg');
        }
        &.fota {
          background-image: url('../../../assets/fota_success_times_bg.jpg');
        }
        .total {
          line-height: 44px;
          font-family: Barlow-SemiBold;
          font-size: 36px;
          font-weight: 600;
          color: #ffffff;
        }
        .day-wrap {
          line-height: 24px;
          font-size: 16px;
          .label {
            margin-right: 8px;
            color: #bfe0ff;
          }
          .value {
            font-weight: 600;
            color: #ffffff;
          }
        }
        .name {
          position: absolute;
          left: 24px;
          bottom: 24px;
          line-height: 22px;
          font-size: 14px;
          color: #ffffff;
        }
      }
      .fota-query {
        position: relative;
        flex: 3;
        padding: 24px;
        margin-left: 24px;
        height: 146px;
        background-image: url('../../../assets/normal_bg.jpg');
        background-repeat: no-repeat;
        background-position: left center;
        background-size: cover;
        border-radius: 15px;
        .total {
          line-height: 44px;
          font-family: Barlow-SemiBold;
          font-size: 36px;
          font-weight: 600;
          color: #333333;
        }
        .day-wrap {
          line-height: 24px;
          font-size: 16px;
          .label {
            margin-right: 8px;
            color: #999999;
          }
          .value {
            font-weight: 600;
            color: #00cbd3;
          }
        }
        .name {
          position: absolute;
          left: 24px;
          bottom: 24px;
          line-height: 22px;
          font-size: 14px;
          color: #666666;
        }
        .el-progress {
          position: absolute;
          top: 50%;
          right: 24px;
          margin-top: -42px;
          path:first-child {
            stroke: #d4eef0;
          }
          .el-progress__text {
            line-height: 24px;
            font-size: 16px !important;
            font-weight: 600;
            color: #333333;
          }
        }
      }
    }
  }
}
.version {
  //margin-top: 24px;
  .title {
    line-height: 24px;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
  }
  .left-wrap {
    position: relative;
    margin: 0 auto;
    width: 500px;
    height: 540px;
    .one {
      position: absolute;
      top: 180px;
      left: 147px;
      width: max-content;
    }
    .two {
      position: absolute;
      top: 334px;
      left: 313px;
      width: max-content;
    }
    .three {
      position: absolute;
      top: 0;
      left: 267px;
      width: max-content;
    }
    .four {
      position: absolute;
      top: 295px;
      left: 0;
      width: max-content;
    }
    .five {
      position: absolute;
      top: 53px;
      left: 40px;
      width: max-content;
    }
    .six {
      position: absolute;
      top: 185px;
      left: 410px;
      width: max-content;
    }
    .hl-empty {
      position: absolute;
      top: 120px;
      left: 50%;
      margin-left: -80px;
    }
  }
  .right-wrap {
    margin-left: 24px;
    padding: 16px;
    width: 420px;
    background: #ffffff;
    box-shadow: 0px -2px 20px 0px rgba(34, 42, 57, 0.05);
    border-radius: 16px;
    .device-count {
      font-size: 18px;
      font-weight: 600;
      color: #339dff;
    }
    .total {
      margin-top: 20px;
      line-height: 22px;
      font-size: 14px;
      color: #3d3737;
      text-align: right;
    }
  }
}
</style>
